import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { MaterialReactTable } from "material-react-table";
import { useNavigate } from "react-router-dom";
import api from "../Axios/api";
import Swal from "sweetalert2";
import Loader from "../common/Loader";
import { FileText, Pencil, Trash2 } from "lucide-react";
const MaterialInOutReport = () => {
  const navigate = useNavigate();
  const userBranch = useSelector((state) => state.user.staff_FacLoc);
  const userName = useSelector((state) => state.user.staff_name);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [activeFactory, setActiveFactory] = useState(null);
  const [isloading, setIsLoading] = useState(false);
  const allowedUsers = ["Admin", "Sameer Khan"];
  const columns = [
    {
      accessorKey: "date",
      header: "Date",
    },
    {
      accessorKey: "voucherNo",
      header: "Voucher.No",
    },
    {
      accessorKey: "name",
      header: "Party Name",
    },
    {
      accessorKey: "location",
      header: "Factory Location",
    },
    {
      accessorKey: "status",
      header: "Bill Receipt",
      Cell: ({ row }) => {
        const { status } = row.original;

        return (
          <button
            className={`px-2 py-1 rounded ${
              status === 0
                ? "bg-gray-500 text-white"
                : "bg-green-600 text-white"
            }`}
            onClick={() => handleStatusChange(row.original.id, status)}
          >
            {status === 0 ? "Pending" : "Received"}
          </button>
        );
      },
    },
    {
      accessorKey: "action",
      header: "Action",
      Cell: ({ row }) => (
        <div>
          <button
            className="text-blue-500 underline hover:text-blue-700 mr-5"
            onClick={() => handlePrint(row.original.info)}
          >
            {" "}
            <FileText size={20} />
          </button>
          <button
            className="text-green-500 underline hover:text-blue-700 mr-5"
            onClick={() => handleEdit(row.original.info)}
          >
            {" "}
            <Pencil size={18} />
          </button>
          <button
            className="text-red-500 underline hover:text-blue-700"
            onClick={() => handleDelete(row.original.id)}
          >
            {" "}
            <Trash2 size={18} />
          </button>
        </div>
      ),
    },
  ];

  const handleStatusChange = async (id, currentStatus) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: !currentStatus
        ? `Do you want to verify this receipt as received?`
        : `Do you want to mark this receipt as pending?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, verify",
      cancelButtonText: "No",
    });
    if (result.isConfirmed) {
      try {
        await api.patch(`material-in-out/verify-received/${id}`);
        await fetchData();

        Swal.fire({
          title: "Verified!",
          text: "Receipt has been marked as received.",
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
        });
      } catch (error) {
        console.error("Verification failed:", error);
        Swal.fire({
          title: "Error!",
          text: "Something went wrong while verifying the receipt.",
          icon: "error",
        });
      }
    }
  };

  const handlePrint = (rowData) => {
    const printWindow = window.open("", "_blank");
    if (printWindow) {
      const data = {
        voucherNo: rowData.voucherNo,
        entryDate: rowData.entryDate,
        challanDate: rowData.challanDate,
        challanNo: rowData.challanNo,
        dispatchThrough: rowData.dispatchThrough,
        destination: rowData.destination,
        deliveryTerms: rowData.deliveryTerms,
        factory: rowData.factoryInfo.fectory_loca_name,
        factAddress: rowData.factoryInfo.fectory_loca_address,
        party: rowData.partyInfo.vendor_name,
        partyAddress: rowData.partyInfo.vendor_address,
        partyNo: rowData.partyInfo.vendor_mobile,
        partyGST: rowData.partyInfo.vendor_gstno,
        narration: rowData.narration,
      };
      const itemRowsHtml = rowData.items
        .map((item, index) => {
          const qty = parseFloat(item.item_qty);
          const rate = parseFloat(item.item_rate);
          const gstRate = parseFloat(item.item_gst) || 0;

          const taxableAmount = (qty * rate).toFixed(2);
          const gstAmount = ((taxableAmount * gstRate) / 100).toFixed(2);
          const totalAmount_withGST = (
            parseFloat(taxableAmount) + parseFloat(gstAmount)
          ).toFixed(2);

          return `
                <tr>
                  <td style="border: 1px solid black;">${index + 1}</td>
                  <td style="border: 1px solid black; padding: 2px;">
                  <strong>${item.item_name.split("_")[1] || "-"}</strong><br/>
                  ${item.item_desc || "-"}</td>
                  <td style="border: 1px solid black; padding: 2px;">${item.item_qty}</td>
                  <td style="border: 1px solid black; padding: 2px;">${item.item_rate}</td>
                  <td style="border: 1px solid black; padding: 2px;"> ${item.item_gst ? item.item_gst + " %" : "0 %"}</td>
                  <td style="border: 1px solid black; padding: 2px;">${item.item_unit}</td>
                  <td style="border: 1px solid black; padding: 2px;">${totalAmount_withGST}</td>
                </tr>`;
        })
        .join("");

      const totalAmount = rowData.items
        .reduce((sum, item) => {
          const qty = parseFloat(item.item_qty) || 0;
          const rate = parseFloat(item.item_rate) || 0;
          const gstRate = parseFloat(item.item_gst) || 0;

          const taxable = qty * rate;
          const gst = (taxable * gstRate) / 100;

          return sum + taxable + gst;
        }, 0)
        .toFixed(2);

      function numberToWords(num) {
        const a = [
          "",
          "One",
          "Two",
          "Three",
          "Four",
          "Five",
          "Six",
          "Seven",
          "Eight",
          "Nine",
          "Ten",
          "Eleven",
          "Twelve",
          "Thirteen",
          "Fourteen",
          "Fifteen",
          "Sixteen",
          "Seventeen",
          "Eighteen",
          "Nineteen",
        ];
        const b = [
          "",
          "",
          "Twenty",
          "Thirty",
          "Forty",
          "Fifty",
          "Sixty",
          "Seventy",
          "Eighty",
          "Ninety",
        ];

        function inWords(n) {
          if (n < 20) return a[n];
          if (n < 100)
            return b[Math.floor(n / 10)] + (n % 10 ? " " + a[n % 10] : "");
          if (n < 1000)
            return (
              a[Math.floor(n / 100)] +
              " Hundred" +
              (n % 100 ? " " + inWords(n % 100) : "")
            );
          if (n < 100000)
            return (
              inWords(Math.floor(n / 1000)) +
              " Thousand" +
              (n % 1000 ? " " + inWords(n % 1000) : "")
            );
          if (n < 10000000)
            return (
              inWords(Math.floor(n / 100000)) +
              " Lakh" +
              (n % 100000 ? " " + inWords(n % 100000) : "")
            );
          return (
            inWords(Math.floor(n / 10000000)) +
            " Crore" +
            (n % 10000000 ? " " + inWords(n % 10000000) : "")
          );
        }

        return num === 0 ? "Zero" : inWords(num);
      }

      const amountInWords = numberToWords(parseInt(totalAmount));

      const totalItem = rowData.items
        .reduce((sum, item) => {
          return sum + parseFloat(item.item_qty || 0);
        }, 0)
        .toFixed(2);

      const tableHtml = `
            <div style="padding:2px; font-family: Arial, sans-serif;">
              <div style="text-align: center; margin-bottom: 2px;">MATERIAL IN</div>
      
  <table style="width: 100%; border-collapse: collapse; margin-bottom:2px;">
               
     <tr>
                  <td colspan="2" style="border: 1px solid black; padding: 5px;">
                   <strong> ${data.factory} </strong> PVT LTD<br/>
                    ${data.factAddress}
                  </td>


                 <td colspan="4" style="border: 1px solid black; padding:5px;">
                        <div style="display: flex; justify-content: start;">
        
                            <div style="border-right: 1px solid black; padding-right: 20px; margin-right: 30px;">
                                <div style="border-bottom: 1px solid black;padding-bottom: 10px; "><strong >Voucher No:</strong> ${data.voucherNo}</div>
                                 <div><strong>Voucher Date:</strong> ${new Date(data.entryDate).toLocaleDateString("en-GB")}</div>


                            </div>

    
                            <div>
                                        <div style="border-bottom: 1px solid black;padding-bottom: 10px;"><strong>Challan No:</strong> ${data.challanNo}</div>
                                        <div><strong>Challan Date:</strong> ${new Date(data.challanDate).toLocaleDateString("en-GB")}</div>
                            </div>
                            
                         </div>
                         
                        <div style="display: flex;border-top:1px solid black;"> 
                            <div>  Destination : <strong>${data.destination}</strong></div>
                        </div>
                </td>
                </tr>
            <tr>

                  <td colspan="2" style="border: 1px solid black; padding: 5px;">
                    <strong>Party (Received At)</strong><br/>
                  <strong> ${data.party} </strong> <br/>
                   ${data.partyAddress}
                   ${data.partyNo}<br/>
                   ${data.partyGST}
                  </td>
                  <td colspan="2" style="border: 1px solid black;padding:5px;">
                    <strong>Terms of Delivery</strong><br/>
                    ${data.deliveryTerms}
                  </td>
             </tr>
       </tr>

                
              </table>
      
              <table style="width: 100%;height:250px; border-collapse: collapse; margin-top: 10px;">
                <thead>
                  <tr>
                    <th style="border: 1px solid black;">SN No.</th>
                    <th style="border: 1px solid black;padding:5px;">Description of Goods</th>
                    <th style="border: 1px solid black;padding:5px;">Quantity</th>
                    <th style="border: 1px solid black;padding:5px;">Rate</th>
                    <th style="border: 1px solid black;padding:5px;">GST</th>
                    <th style="border: 1px solid black;padding:5px;">Per</th>
                    <th style="border: 1px solid black;padding:5px;">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  ${itemRowsHtml}
                </tbody>
               <tfoot>
                  <tr>
                  <td style="border: 1px solid black; text-align: right;"></td>
              <td style="border: 1px solid black; text-align: right;padding-right: 10px;"><strong>Total </strong></td>
              <td  style="border: 1px solid black;"><strong style="padding: 5px;">${totalItem}</strong></td>
                    <td style="border: 1px solid black; text-align: right;"></td>
                    <td style="border: 1px solid black; text-align: right;"></td>
                        <td style="border: 1px solid black; text-align: right;"></td>
              <td  colspan="3"  style="border: 1px solid black;"><strong style="padding: 5px;">₹${totalAmount}</strong></td>
            </tr>
                </tfoot>
              </table>
      
            <!--  <div style="margin-top: 10px; font-size: 14px;">
                <div><strong>Inspection Report:</strong> Accepted</div>
                <div><strong>Payment Terms:</strong> 15 Days</div>
              </div> -->
      
              <div style="margin-top: 20px; text-align: center;">
                <table style="width: 100%; border: 1px solid black; border-collapse: collapse;">
                 <tr>
                  <td colspan="7" style="padding:5px;">  Amount Chargeable (in words)  <strong> ${amountInWords} Rupees Only</strong> </td>
                 </tr>
             

                  <tr>
                  <td style="border: 1px solid black; padding: 2px; width:120px; vertical-align: top;">
                    <strong>Remarks :</strong><br/>
                   <span style="font-size : 10px;">${data.narration}</span>
                  </td>
                    <td colspan = "3" style="border: 1px solid black;text-align: right;padding-right:10px;">
                          
                     <strong>for ${data.factory} </strong> PVT LTD <br/>By Authorised Signatory</td>
                  </tr>
                </table>
              </div>

               <div style="margin-top: 20px; text-align: center;">
                  <table style="width: 100%; height: 80px; border: 1px solid black; border-collapse: collapse;">
                      <tr class="text-center fw-medium">
                          <td style="border: 1px solid black;">
                              <div class="fs-5">Prepared</div>
                              <div class="fs-5">By Store</div>
                          </td>
                          <td style="border: 1px solid black;">
                              <div class="fs-5">Inspected</div>
                              <div class="fs-5">By User</div>
                          </td>
                          <td style="border: 1px solid black;">
                              <div class="fs-5">Bill Processed</div>
                              <div class="fs-5">By Authorized</div>
                          </td>
                          <td style="border: 1px solid black;">
                              <div class="fs-5">Audited</div>
                              <div class="fs-5">By Authorized</div>
                          </td>
                      </tr>
                </table>
              </div>

            </div>
          `;

      printWindow.document.write(`
            <html>
              <head>
                <title>Material In/Out</title>
                <style>
                  body {
                    margin: 0;
                    font-family: Arial, sans-serif;
                  }
                  th, td {
                    text-align: left;
                    padding: 0px;
                    font-size:12px;
                  }
                </style>
              </head>
              <body>
                ${tableHtml}
              </body>
            </html>
          `);
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
      // printWindow.close();
    }
  };
  const handleEdit = (row) => {
    // console.log('edit=>',row);return
    navigate(`/material-in-out-form`, {
      state: {
        userData: row,
      },
    });
  };
  const handleDelete = async (row) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      try {
        const response = await api.delete(`/material-in-out/delete/${row}`);
        if (response) {
          Swal.fire({
            title: "Deleted!",
            text: "Data deleted successfully!",
            icon: "success",
            timer: 2000,
            showConfirmButton: false,
          });
          fetchData();
        }
      } catch (error) {
        console.error("Error deleting data:", error);
        Swal.fire({
          title: "Error!",
          text: "Something went wrong while deleting the data.",
          icon: "error",
        });
      }
    }
  };
  const fetchData = async () => {
    try {
      setIsLoading(true);
      const res = await api.get(`/material-in-out/getAll`);
      const transformedData = res.data.map((item, index) => ({
        sn: index + 1,
        voucherNo: item.voucherNo,
        id: item._id,
        factory: item.factory,
        date: new Date(item.entryDate)
          .toLocaleDateString("en-GB")
          .split("T")[0],
        name: item.partyInfo.vendor_name,
        status: item.status,
        location: item.factoryInfo.fectory_loca_name,
        info: res.data[index],
      }));
      const finalData =
        userName === "Admin" || userName === "Sameer Khan"
          ? transformedData
          : transformedData.filter((item) => item.factory === userBranch);
      setData(finalData);
      setFilteredData(finalData);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleFilter = (factoryId) => {
    setActiveFactory(factoryId);
    if (!factoryId) {
      setFilteredData(data);
    } else {
      setFilteredData(data.filter((item) => item.factory === factoryId));
    }
  };

  return (
    <div className="p-6">
      <div className="flex flex-row items-center justify-between bg-white p-3 mb-3 rounded-lg">
        <h1 className="text-2xl font-bold mb-0 text-gray-800">
          Material In/Out Report
        </h1>
        <button
          className="bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600"
          onClick={() => {
            navigate("/material-in-out-form");
          }}
        >
          Add Form
        </button>
      </div>

      {allowedUsers.includes(userName) && (
        <div className="mb-4 space-x-2">
          <button
            className={`px-3 py-1 rounded ${
              activeFactory === null ? "bg-blue-600 text-white" : "bg-gray-300"
            }`}
            onClick={() => handleFilter(null)}
          >
            All
          </button>
          <button
            className={`px-3 py-1 rounded ${
              activeFactory === "666c0f5ebeca5ab2c65b2c85"
                ? "bg-blue-600 text-white"
                : "bg-gray-300"
            }`}
            onClick={() => handleFilter("666c0f5ebeca5ab2c65b2c85")}
          >
            INSULATION
          </button>
          <button
            className={`px-3 py-1 rounded ${
              activeFactory === "666c0f5ebeca5ab2c65b2c86"
                ? "bg-blue-600 text-white"
                : "bg-gray-300"
            }`}
            onClick={() => handleFilter("666c0f5ebeca5ab2c65b2c86")}
          >
            PROJECTS
          </button>
          <button
            className={`px-3 py-1 rounded ${
              activeFactory === "666c0f5ebeca5ab2c65b2c87"
                ? "bg-blue-600 text-white"
                : "bg-gray-300"
            }`}
            onClick={() => handleFilter("666c0f5ebeca5ab2c65b2c87")}
          >
            ROCKFIBRE
          </button>
        </div>
      )}

      {/* Table */}
      {isloading ? (
        <Loader />
      ) : (
        <MaterialReactTable
          columns={columns}
          data={filteredData}
          enablePagination
          enableBottomToolbar
          muiTableBodyRowProps={{
            hover: true,
          }}
        />
      )}
    </div>
  );
};

export default MaterialInOutReport;
